var _Glyphicon;
import React from 'react';
import clsx from 'clsx';
import { Glyphicon, Label, PartnerLink } from 'reaxl';

/**
 *  Renders a product badge for use in InventoryListingBadges
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ProductBadge(_ref) {
  let {
    label,
    link,
    onClick,
    tileType
  } = _ref;
  const showIcon = tileType === 'EXPERIAN_RETAIL';
  return label && /*#__PURE__*/_jsx(Label, {
    bsStyle: "info-inverse",
    "data-cmp": "productBadge",
    children: /*#__PURE__*/_jsxs(PartnerLink, {
      className: clsx({
        'display-inline-flex gap-1': showIcon
      }, 'text-inherit'),
      href: link?.href,
      onClick: onClick,
      children: [showIcon && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
        glyph: "usd-circle"
      }))), label]
    })
  });
}
export default ProductBadge;